













































import { Vue, Component, Prop } from 'vue-property-decorator';
import { globalModule } from '@/store/modules/global.module';
import { cookieService } from '@/service/cookie.service';
import { Constants } from '@/constants/constants';
import { GEnum } from '@/constants/enum.defination';
import { Menu } from '@/models/menu';
import { HeadMenu } from '@/constants/constants';
import { DateUtils } from '@/utils/date.utils';
import { activeMenuStorageService } from '@/service/storage/active-menu-storage.service';

@Component({
  name: 'GDefaultTemplateMenu',
  computed: {},
  methods: {},
})
export default class GDefaultTemplateMenu extends Vue {
  @Prop() selectedSchoolYear: number;

  mounted() {}

  get mainMenus(): Menu[] {
    if (globalModule.selectedSchoolYear < globalModule.currentSchoolYear) {
      // 過去年度の場合
      return [HeadMenu.ClassManagement, HeadMenu.SettingAndManagement];
    } else if (this.$store.state.account && this.$store.state.account.isCompletedInitialSetting) {
      // 初期設定or進級設定が終了していたら
      // 画面制御タイプが「内田洋行」の場合
      if (this.$store.state.account.dispCtrlType === GEnum.DispCtrlType.Uchida) {
        return [HeadMenu.Home, HeadMenu.ClassManagement, HeadMenu.ExamList, HeadMenu.SettingAndManagementUchida]; 
      }
      return [HeadMenu.Home, HeadMenu.ClassManagement, HeadMenu.Statistics, HeadMenu.ExamList, HeadMenu.SettingAndManagement];
    } else {
      // 進級処理、初期設定が必要な場合
      return [this.$store.state.account && this.$store.state.account.isPromotion ? HeadMenu.Promotion : HeadMenu.InitSetting, HeadMenu.SettingAndManagement];
    }
  }

  get helpMenu(): Menu {
    return HeadMenu.Help;
  }

  get activeMenuName(): string {
    return globalModule.activeMenu !== '' ? globalModule.activeMenu : activeMenuStorageService.activeMenu;
  }

  get isJgrow(): boolean {
    return process.env.VUE_APP_SERVICE_NAME === Constants.ServiceNameJgrow;
  }

  get isLangJa(): boolean {
    return cookieService.language == "ja";
  }

  /**
   * 内田洋行タイプ
   */
  get isDispCtrlTypeUchida(): boolean {
    if (this.$store.state.account === undefined) return false;
    return this.$store.state.account.dispCtrlType === GEnum.DispCtrlType.Uchida;
  }

  get themeClass(): string {
    if (
      this.selectedSchoolYear > DateUtils.currentSchoolYear(globalModule.currentDate) ||
      (this.$store.state.account &&
        !this.$store.state.account.isCompletedInitialSetting &&
        this.$store.state.account.isPromotion &&
        this.selectedSchoolYear === DateUtils.currentSchoolYear(globalModule.currentDate))
    ) {
      // 年度が次年度であるか、同年度で進級未設定だった場合
      return 'bg-red-5';
    } else if (this.selectedSchoolYear === DateUtils.currentSchoolYear(globalModule.currentDate)) {
      if (this.isJgrow) {
        return 'jsgrow';
      } else {
        return 'primary';
      }
    }
    // 過去年度
    return 'bg-gray-8';
  }

  setActiveMenu(menuID: string) {
    if (menuID === HeadMenu.Help.menuID) {
      // ヘルプは外部リンクのため、状態としては変更なし
      globalModule.setActiveMenu(HeadMenu.Home.menuID);
      return;
    }
    activeMenuStorageService.activeMenu = menuID;
    globalModule.setActiveMenu(menuID);
  }
}
